import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberDecimalsLimit]',
  standalone: false
})
export class NumberDecimalsLimitDirective {
  // Solo permite números enteros o con hasta 4 decimales
  private regex: RegExp = /^\d+(\.\d{0,4})?$/;
  private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.specialKeys.includes(event.key) || (event.ctrlKey || event.metaKey)) {
      return;
    }

    const input = this.el.nativeElement;
    const current: string = input.value;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;

    const newValue = [
      current.slice(0, selectionStart),
      event.key,
      current.slice(selectionEnd)
    ].join('');

    if (!this.regex.test(newValue)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const input = this.el.nativeElement;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;

    const newValue = [
      input.value.slice(0, selectionStart),
      clipboardData,
      input.value.slice(selectionEnd)
    ].join('');

    // Limpiar texto (por si vienen caracteres extraños)
    const sanitized = newValue.replace(/[^\d.]/g, '');

    if (this.regex.test(sanitized)) {
      input.value = sanitized;
      input.dispatchEvent(new Event('input')); // Para que se actualice formControlName
    }
  }
}
